export default "__VITE_ASSET__j0V5_4MB__"